export const SET_DRUG_LIST = 'SET_DRUG_LIST';
